import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const ModelsView = lazy(() => import("../../container/crud/models/index"));
const AddModelsView = lazy(() => import("../../container/crud/models/Add"));

const PagesRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/view`} component={ModelsView} />
      <Route path={`${path}/add`} component={AddModelsView} />
      <Route path={`${path}/edit/:id`} component={AddModelsView} />
    </Switch>
  );
};

export default PagesRoute;
